import { AccordionDetails, Button, CircularProgress, FormControl, Grid, TextField, Typography } from '@mui/material';
import React from 'react';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useAppSelector } from 'src/store';
import { usePreferedDateFormat } from 'src/util/DateFormatter';

const Signatures: React.FunctionComponent<any> = ({
  signature,
  handleSign,
  isDisable,
  updateSignIsLoading,
  handleSignReviewedBy,
  handleSignApprovedBy,
  handleCheck,
  handleSaveSignature,
  imvReportData,
  commentErr,
  disable
}) => {
  const user = useAppSelector(state => state.user.user);
  const { checkPermission } = usePermissionWrapper();
  const signIMVRPermission = checkPermission('update_signature_imvreport');
  const { getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const username = `${user?.firstName} ${user?.lastName}`;

  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checklist-radio-actions" spacing={1}>
        <Grid item md={12}>
          <Grid container mt={2} mb={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={2}>
              Prepared By:
            </Grid>
            {!signature?.stdy_imvrp_prepared_by ? (
              <Grid item md={10}>
                {updateSignIsLoading ? (
                  <CircularProgress size="1.5rem" style={{ position: 'absolute', right: '18px' }} />
                ) : (
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleSign('stdy_imvrp_prepared_by', 'stdy_imvrp_prepared_date')}
                    disabled={!isDisable || disable || !imvReportData?.created_on}
                  >
                    Sign
                  </Button>
                )}
              </Grid>
            ) : (
              <Grid item md={10}>
                <Typography>
                  <span style={{ fontSize: '13px' }}>Signed by </span>
                  <strong>{signature?.stdy_imvrp_prepared_by}</strong>
                  <span style={{ color: '#00000070', fontWeight: 400, fontSize: '13px' }}>
                    {''} {getPreferredDateTimeInLocal(signature?.stdy_imvrp_prepared_date)}
                  </span>
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item md={12}>
          <Grid container mt={2} mb={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={2}>
              Reviewed By:
            </Grid>
            {!signature?.stdy_imvrp_reviewed_by ? (
              <Grid item md={10}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => handleSignReviewedBy('stdy_imvrp_reviewed_by', 'stdy_imvrp_reviewed_date')}
                  disabled={
                    !signIMVRPermission ||
                    disable ||
                    !signature?.stdy_imvrp_prepared_by ||
                    (imvReportData?.notify_user ? imvReportData?.notify_user !== username : true)
                  }
                >
                  Sign
                </Button>
              </Grid>
            ) : (
              <Grid item md={10}>
                <Typography>
                  <span style={{ fontSize: '13px' }}>Signed by </span>
                  <strong>{signature?.stdy_imvrp_reviewed_by}</strong>
                  <span style={{ color: '#00000070', fontWeight: 400, fontSize: '13px' }}>
                    {''} {getPreferredDateTimeInLocal(signature?.stdy_imvrp_reviewed_date)}
                  </span>
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item md={12}>
          <Grid container mt={2} mb={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={2}>
              Final Approval By:
            </Grid>
            {!signature?.stdy_imvrp_approval_by ? (
              <Grid item md={10}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => handleSignApprovedBy('stdy_imvrp_approval_by', 'stdy_imvrp_approved_date')}
                  disabled={
                    !signIMVRPermission ||
                    disable ||
                    !signature?.stdy_imvrp_reviewed_by ||
                    (imvReportData?.notify_user ? imvReportData?.notify_user !== username : true)
                  }
                >
                  Sign
                </Button>
              </Grid>
            ) : (
              <Grid item md={10}>
                <Typography>
                  <span style={{ fontSize: '13px' }}>Signed by </span>
                  <strong>{signature?.stdy_imvrp_approval_by}</strong>
                  <span style={{ color: '#00000070', fontWeight: 400, fontSize: '13px' }}>
                    {''} {getPreferredDateTimeInLocal(signature?.stdy_imvrp_approved_date)}
                  </span>
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item md={12}>
          <Grid container mt={1} mb={1} rowSpacing={1}>
            <Grid item md={12}>
              <FormControl fullWidth margin="normal">
                <TextField
                  required
                  error={commentErr}
                  helperText={commentErr ? 'Required' : null}
                  id="standard-select-currency-native"
                  label="Additional Notes"
                  variant="standard"
                  name="stdy_imvrp_add_comments"
                  value={signature?.stdy_imvrp_add_comments}
                  onChange={e => handleCheck(e, 'signatures')}
                  disabled={!signature?.stdy_imvrp_approval_by || imvReportData?.signature?.stdy_imvrp_add_comments}
                  InputLabelProps={{ shrink: true }}
                />
              </FormControl>
            </Grid>
            <Grid item md={12} sx={{ textAlign: 'right' }}>
              <Button
                variant="text"
                disabled={!signature?.stdy_imvrp_approval_by || imvReportData?.signature?.stdy_imvrp_add_comments}
                onClick={() => handleSaveSignature()}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default Signatures;
